<template>
  <Panel :isActive="true" :title="t.getOrKey('Label.ReservationDetails')">
    <Loader :loading="loading">
      <section v-if="reservation">
        <h3>
          <font-awesome-icon :icon="['fas', 'question']"></font-awesome-icon>
          {{ t.getOrKey("Label.Status") }}
        </h3>
        <div :class="['status-' + reservation.status.status.toLowerCase()]">
          {{ reservation.status.name }}
        </div>
        <hr />
        <h3>
          <font-awesome-icon :icon="['fas', 'layer-group']"></font-awesome-icon>
          {{ t.getOrKey("Label.SelectedServices") }}
        </h3>
        <div v-for="service in reservation.services" :key="service.id">
          <div>
            <h4>{{ service.name }}</h4>

            <div
              v-if="
                service.additionalQuestions &&
                  service.additionalQuestions.length
              "
            >
              <div
                v-for="aq in service.additionalQuestions"
                :key="aq.question.id"
              >
                <label>{{ aq.question }}:</label>
                <div v-if="aq.type === 'File' && aq.files">
                  <div v-for="file in aq.files" :key="file.reference">
                    <a :href="file.url" target="_blank">{{ file.fileName }}</a>
                  </div>
                </div>
                <span v-else>&nbsp;{{ aq.displayValue }}</span>
              </div>
            </div>
            <div
              v-if="service.selectedOptions && service.selectedOptions.length"
            >
              <h5>
                {{ t.getOrKey("Label.SelectedServiceAdditionalOptions") }}
              </h5>

              <div v-for="opt in service.selectedOptions" :key="opt.id">
                {{ opt.name }}
                {{
                  opt.priceInEURCents > 0 ? opt.priceInEURCents / 100 + "€" : ""
                }}
              </div>
            </div>
          </div>
          <hr />
        </div>

        <div>
          <h3>
            <font-awesome-icon
              :icon="['fas', 'map-marker-alt']"
            ></font-awesome-icon>
            {{ t.getOrKey("Label.Provider") }}
          </h3>
          <div>
            <label>{{ reservation.provider.name }}</label>
          </div>
          <div>{{ reservation.provider.street }}</div>
          <div>{{ reservation.provider.city }}</div>
        </div>
        <hr />
        <div>
          <h3>
            <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
            {{ t.getOrKey("Label.Time") }}
          </h3>
          <div>
            <label>{{ t.getOrKey("Label.Start") }}:</label>
            {{ formatDate(new Date(reservation.start)) }}
            {{ formatTime(new Date(reservation.start)) }}
          </div>
        </div>
        <hr />
        <h3>
          <font-awesome-icon :icon="['fas', 'user-edit']"></font-awesome-icon>
          {{ t.getOrKey("Label.ReserverDetails") }}
        </h3>
        <div>
          <label>{{ t.getOrKey("Label.ReserverName") }}:</label>
          <span>&nbsp;{{ reservation.address.name }}</span>
        </div>

        <div>
          <label>{{ t.getOrKey("Label.RegistrationNumber") }}:</label>
          <span>&nbsp;{{ reservation.registrationNumber }}</span>
        </div>
        <div>
          <label>{{ t.getOrKey("Label.Email") }}:</label>
          <span>&nbsp;{{ reservation.address.email }}</span>
        </div>
        <div>
          <label>{{ t.getOrKey("Label.ReserverPhone") }}:</label>
          <span>&nbsp;{{ reservation.address.phone }}</span>
        </div>
        <div>
          <div>
            <label>{{ t.getOrKey("Label.AdditionalInfo") }}</label>
          </div>
          <div>{{ reservation.additionalInfo }}</div>
          <div v-if="false">
            <label>{{ reservation.remindSMSStatus.name }}</label>
          </div>
        </div>
        <hr />
        <div v-if="reservation.isCancelValid">
          <button class="error" @click="cancelReservation">
            {{ t.getOrKey("Button.CancelReservation") }}
          </button>
        </div>
      </section>
    </Loader>
  </Panel>
</template>
<script>
import util from "@/services/utils";
import api from "@/services/api-service";
import t from "@/services/translation-service";
import Loader from "./Loader.vue";
import Panel from "./Panel.vue";

export default {
  components: {
    Loader,
    Panel,
  },
  props: {
    reservationKey: String,
  },
  data() {
    return {
      t: t,
      reservation: undefined,
      loading: true,
    };
  },
  methods: {
    formatDate: util.formatDate,
    formatTime: util.formatTime,
    cancelReservation() {
      this.loading = true;
      api
        .cancelReservation(this.reservation.id)
        .then((response) => {
          this.reservation = response.data;
        })
        .catch((error) => {
          console.log(error, error.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.loading = true;
    api
      .getReservation(this.reservationKey)
      .then((data) => {
        this.reservation = data;
      })
      .finally(() => {
        setTimeout(function() {
          window.scrollTo(0, 0);
        }, 100);
        this.loading = false;
      });
  },
};
</script>
<style scoped>
hr {
  border: solid 1px #f1f1f1;
  margin-top: 22px;
}
.smsContainer {
  margin-bottom: 2rem;
}
label {
  font-weight: 500;
}
</style>
